import {StyledGeneralContainer} from 'src/components/common/styles';
import {NavigationBarMainViewSelect} from './NavigationBarMainViewSelect';
import {useNavigationBarContainerStyles} from './styles';
import {JSX} from 'react';

export function MainNavigationBar(): JSX.Element {
  const { classes: {mainViewSelect} } = useNavigationBarContainerStyles();

  return (
    // <Paper className={container}>
    <StyledGeneralContainer>
      <div className={mainViewSelect}>
        <NavigationBarMainViewSelect />
      </div>
    </StyledGeneralContainer>
     // </Paper>
  );
}
